<template>
	<v-dialog
		v-model="open"
		max-width="700"
		@click:outside="$emit('close')"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">製造単位別製品情報詳細</v-toolbar-title>
				<v-spacer></v-spacer>

				<v-btn icon dark @click="$emit('close')" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-row no-gutters class="mt-4" justify="end">
				<v-btn color="secondary" @click="openRelatedMatterPage"> 案件詳細 </v-btn>
			</v-row>
			<v-sheet elevation="0" class="pa-2">
				<v-sheet elevation="0" class="mt-4">
					<table width="100%" class="show-dialog-table mt-2 mb-4" :key="ordered_product.id">
						<tr>
							<td colspan="2" style="border: none" class="px-0">
								<h4 class="text-h6 my-1">
									{{ ordered_product.product.name }} {{ ordered_product.sub_name }}
								</h4>
							</td>
						</tr>

						<tbody>
							<h5 class="text-h6 font-weight-bold color-secondary my-1">製品情報</h5>
							<tr>
								<th width="30%" class="font-weight-bold">製造番号</th>
								<td width="70%">
									{{ ordered_product.product_number }}-{{
										common.zeroPadding(order_individual_info.sub_number, 3)
									}}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">数量</th>
								<td width="70%">{{ order_individual_info.quantity }}</td>
							</tr>
							<h5 class="text-h6 font-weight-bold color-secondary my-1">納入先</h5>
							<span style="display: contents">
								<tr>
									<th width="30%" class="font-weight-bold">納期</th>
									<td width="70%">
										{{ common.formatDateWithDay(order_individual_info.delivery_info.deadline) }}
									</td>
								</tr>
								<tr>
									<th width="30%" class="font-weight-bold">出荷日</th>
									<td width="70%">
										{{
											order_individual_info.delivery_info.shipping_date
												? common.formatDateWithDay(
														order_individual_info.delivery_info.shipping_date
												  )
												: "未設定"
										}}
									</td>
								</tr>

								<tr>
									<th width="30%" class="font-weight-bold">会社名</th>
									<td width="70%">{{ order_individual_info.delivery_info.company_name }}</td>
								</tr>
								<tr>
									<th width="30%" class="font-weight-bold">担当者</th>
									<td width="70%">{{ order_individual_info.delivery_info.person_name }}</td>
								</tr>

								<tr>
									<th width="30%" class="font-weight-bold">郵便番号</th>
									<td width="70%">{{ order_individual_info.delivery_info.zipcode }}</td>
								</tr>

								<tr>
									<th width="30%" class="font-weight-bold">住所</th>
									<td width="70%">{{ order_individual_info.delivery_info.address }}</td>
								</tr>
								<tr>
									<th width="30%" class="font-weight-bold">電話</th>
									<td width="70%">{{ order_individual_info.delivery_info.phone }}</td>
								</tr>
								<tr>
									<th width="30%" class="font-weight-bold">Fax</th>
									<td width="70%">{{ order_individual_info.delivery_info.fax }}</td>
								</tr>
							</span>
							<div style="height: 24px; width: auto"></div>
						</tbody>
					</table>
				</v-sheet>
			</v-sheet>

			<v-card-actions>
				<v-row no-gutters>
					<v-col cols="8" />
					<v-col cols="4">
						<v-row no-gutters justify="end">
							<v-btn color="grey darken-1" text @click="$emit('close')"> 閉じる </v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import common from "../../helper/common"
export default {
	props: {
		ordered_product: {
			type: Object,
			required: true,
			default: () => [],
		},
		order_individual_info: {
			type: Object,
			required: true,
			default: () => {},
		},
	},
	data() {
		return {
			common: common,
			open: true,
		}
	},
	methods: {
		openRelatedMatterPage() {
			window.open("/matters/" + this.ordered_product.matter_id, "_blank")
		},
	},
}
</script>

<style lang="scss" scoped>
table {
	border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
